
const UserTypeToColor: Record<string, string> = {
    ADMIN: "red",
    OPT: "orange",
    REGULAR: "blue",
    SUPEROPT: "redorange",
};

const GetAvatarNikFromName = (name: string, lastname: string): string =>{
    return name?.charAt(0).toUpperCase()+lastname?.charAt(0).toUpperCase();
}

export { UserTypeToColor, GetAvatarNikFromName };
